<div class="layout">
  <div class="layout__content">
    <div class="layout__inner">
      <router-outlet></router-outlet>
    </div>
  </div>
</div>
